<mat-expansion-panel class="panel">
  <mat-expansion-panel-header>
    <mat-panel-title>{{ 'ASSOCIATIONS.CAMPAIGNS.TITLE' | translate }}</mat-panel-title>
  </mat-expansion-panel-header>
  <button
    mat-stroked-button
    *ngIf="!loadingAccountGroup(); else loading"
    color="primary"
    class="button-company"
    (click)="viewCampaigns()"
  >
    {{ 'ASSOCIATIONS.PANEL_IN_PROGRESS.BUTTON' | translate : { category: 'campaigns' } }}
  </button>
  <p class="copy-card">
    {{ 'ASSOCIATIONS.PANEL_IN_PROGRESS.DESCRIPTION' | translate : { category: 'campaigns' } }}
  </p>
  <ng-template #loading>
    <mat-spinner class="loading-spinner" diameter="30"></mat-spinner>
  </ng-template>
</mat-expansion-panel>
